export default __webpack_public_path__ + "static/media/about-new2.daa8ce6a.jpg";